import { Style, Avatar } from "@dicebear/core";
import definition from "@dicebear/styles/glass.json" with { type: "json" };

import { config } from "../constants/betterHtml";

const backgroundColors = [config.theme?.colors?.light?.primary, config.theme?.colors?.light?.three, "#f7b84b"]
   .filter((color) => color !== undefined)
   .map((color) => color.slice(1));

const style = new Style(definition);

export const getProfileImage = (seed: string | number) => {
   const avatar = new Avatar(style, {
      size: 256,
      seed: seed.toString(),
      shapeVariant: ["i"],
      // shapeVariant: [],
      backgroundColor: backgroundColors,
      backgroundColorFill: ["linear"],
      backgroundColorAngle: [180, -180],
   });

   return avatar.toDataUri();
};
